// normalize CSS across browsers
import "normalize.css"
import { GmgAssistant } from "./src/helpers/gmg"

GmgAssistant.init({})
